import type { ComponentThemeStyles } from './types';

export const playfulTheme: ComponentThemeStyles = {
  typography: {
    headingFont: 'Fredoka, system-ui, sans-serif',
    bodyFont: 'Nunito, system-ui, sans-serif',
    baseSize: '16px',
  },
  navbar: {
    background: 'bg-gradient-to-r from-purple-400 to-pink-400',
    text: 'text-white',
    brandText: 'text-white',
    linkText: 'text-white',
    linkHover: 'hover:text-yellow-200',
    border: '',
    shadow: 'shadow-xl',
  },
  navigationMenu: {
    background: 'bg-gradient-to-r from-purple-400 to-pink-400',
    text: 'text-white',
    brandText: 'text-white',
    linkText: 'text-white',
    linkHover: 'hover:text-yellow-200',
    border: '',
    shadow: 'shadow-xl',
    dropdownBackground: 'bg-white',
    dropdownText: 'text-gray-800',
    dropdownHover: 'hover:bg-purple-50',
  },
  hero: {
    background: 'bg-gradient-to-br from-pink-500 to-purple-600',
    text: 'text-white',
    buttonStyle: 'bg-yellow-400 text-gray-900 hover:bg-yellow-300',
    overlay: '',
    pattern: true,
  },
  splitHero: {
    background: '#ffffff',
    text: '#111827',
    titleColor: '#000000',
    subtitleColor: '#6b7280',
    taglineColor: '#a855f7',
    buttonBg: '#facc15',
    buttonText: '#000000',
    buttonHover: '#eab308',
  },
  htmlSplit: {
    background: '#ffffff',
    text: '#111827',
    titleColor: '#000000',
    subtitleColor: '#6b7280',
    taglineColor: '#a855f7',
    buttonBg: '#facc15',
    buttonText: '#000000',
    buttonHover: '#eab308',
  },
  simpleHeader: {
    background: '#fef3c7',
    titleColor: '#701a75',
    subtitleColor: '#a21caf',
  },
  features: {
    background: 'bg-gradient-to-br from-purple-50 to-pink-50',
    cardBg: 'bg-white',
    iconColor: 'text-purple-600',
    titleColor: 'text-gray-900',
    textColor: 'text-gray-600',
    borderRadius: 'rounded-2xl',
  },
  footer: {
    background: 'bg-gradient-to-r from-purple-600 to-pink-600',
    text: 'text-white',
    mutedText: 'text-purple-200',
    border: '',
  },
  cta: {
    background: 'bg-gradient-to-r from-yellow-400 to-orange-400',
    text: 'text-gray-900',
    buttonStyle: 'bg-purple-600 text-white hover:bg-purple-700',
  },
  form: {
    background: 'bg-gradient-to-br from-purple-50 to-pink-50',
    inputBg: 'bg-white',
    inputBorder: 'border-purple-300',
    inputText: 'text-gray-900',
    labelColor: 'text-purple-700',
    buttonStyle: 'bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:opacity-90',
  },
  pricing: {
    background: 'bg-gradient-to-br from-purple-50 to-pink-50',
    cardBg: 'bg-white',
    highlightedCard: 'bg-gradient-to-br from-purple-500 to-pink-500 text-white',
    titleColor: 'text-gray-900',
    subtitleColor: 'text-purple-700',
    descriptionColor: 'text-purple-600',
    planTitle: 'text-gray-900',
    planDescription: 'text-purple-600',
    priceColor: 'text-gray-900',
    periodColor: 'text-purple-600',
    featureColor: 'text-gray-700',
    checkColor: '#a855f7',
    highlightedTitle: 'text-white',
    highlightText: '#a855f7',
    highlightedDescription: 'text-purple-100',
    highlightedPrice: 'text-white',
    highlightedPeriod: 'text-purple-100',
    highlightedFeature: 'text-white',
    highlightedCheckColor: '#fbbf24',
    borderColor: 'border-purple-200',
    highlightBorder: 'border-purple-400',
    highlightRing: 'ring-purple-500',
    hoverGlow: 'hover:shadow-purple-500/25',
    badgeBg: '#a855f7',
    badgeText: 'white',
    buttonBg: '#a855f7',
    highlightedButtonBg: '#fbbf24',
  },
  mediaText: {
    background: '#fef3c7',
    titleColor: '#78350f',
    textColor: '#92400e',
    accentColor: '#a855f7',
  },
  faq: {
    background: '#fdf4ff',
    titleColor: '#701a75',
    subtitleColor: '#a21caf',
    questionColor: '#701a75',
    answerColor: '#86198f',
    itemBackground: '#ffffff',
    itemBorder: '#f0abfc',
    iconColor: '#a855f7',
  },
  testimonials: {
    background: '#fef3c7',
    titleColor: '#701a75',
    subtitleColor: '#a21caf',
    cardBackground: '#ffffff',
    cardBorder: '#f0abfc',
    quoteColor: '#86198f',
    nameColor: '#701a75',
    roleColor: '#a21caf',
    starColor: '#fbbf24',
  },
  countdownTimer: {
    background: '#fef3c7',
    text: '#701a75',
    headline: '#701a75',
    subheadline: '#a21caf',
    number: '#a21caf',
    label: '#86198f',
  },
  imageGallery: {
    background: '#fef3c7',
    text: '#701a75',
    title: '#701a75',
    subtitle: '#a21caf',
    caption: '#86198f',
    filterButton: '#fde68a',
    filterButtonActive: '#a21caf',
  },
  imageInfo: {
    background: '#fef3c7',
    text: '#701a75',
    title: '#701a75',
    subtitle: '#a21caf',
    imageBorder: '#fde68a',
    buttonBg: '#a21caf',
    buttonText: '#ffffff',
  },
  imageCard: {
    background: '#fef3c7',
    overlayColor: '#701a75',
    title: '#ffffff',
    description: '#fde68a',
    buttonBg: '#a21caf',
    buttonText: '#ffffff',
  },
  team: {
    background: '#fef3c7',
    cardBg: '#ffffff',
    nameColor: '#701a75',
    roleColor: '#a21caf',
    borderColor: '#f0abfc',
  },
  video: {
    background: '#fef3c7',
    titleColor: '#701a75',
    subtitleColor: '#a21caf',
    textColor: '#86198f',
  },
  textBlocks: {
    background: '#ffffff',
    titleColor: '#701a75',
    textColor: '#86198f',
    linkColor: '#a855f7',
  },
  titleSubtitle: {
    background: '#fef3c7',
    titleColor: '#701a75',
    subtitleColor: '#a21caf',
    buttonBg: '#a855f7',
    buttonText: '#ffffff',
  },
  contactInfo: {
    background: '#fef3c7',
    titleColor: '#701a75',
    textColor: '#86198f',
    accentColor: '#a855f7',
  },
  headContent: {},
  bodyEnd: {},
  htmlEmbed: {
    background: '#ffffff',
  },
  promoBanner: {
    background: '#a855f7',
    text: '#ffffff',
    linkText: '#ffffff',
    dismissButton: '#ffffff',
  },
  logocloud: {
    background: '#fef9c3',
    titleColor: '#92400e',
    subtitleColor: '#a16207',
  },
  stats: {
    background: '#fefce8',
    titleColor: '#92400e',
    subtitleColor: '#a16207',
    valueColor: '#f59e0b',
    labelColor: '#78350f',
    descriptionColor: '#a16207',
  },
  blogPreview: {
    background: '#fef3c7',
    titleColor: '#92400e',
    subtitleColor: '#a16207',
    cardBackground: '#ffffff',
    cardTitle: '#78350f',
    cardExcerpt: '#a16207',
    linkColor: '#f59e0b',
  },
  conversionPopup: {
    overlay: 'rgba(0,0,0,0.5)',
    panelBackground: '#ffffff',
    headlineColor: '#78350f',
    bodyTextColor: '#92400e',
    buttonBackground: '#f59e0b',
    buttonText: '#1c1917',
    closeButton: '#a16207',
  },
  blog: {
    pageBackground: '#fef3c7',
    headerBackground: '#ffffff',
    titleColor: '#701a75',
    descriptionColor: '#a21caf',
    textColor: '#86198f',
    mutedTextColor: '#a21caf',
    linkColor: '#a855f7',
    linkHoverColor: '#9333ea',
    cardBackground: '#ffffff',
    cardBorder: '#f0abfc',
    cardShadow: '0 4px 6px rgba(168, 85, 247, 0.1)',
    cardHoverShadow: '0 10px 15px rgba(168, 85, 247, 0.2)',
    postTitleColor: '#701a75',
    postTextColor: '#86198f',
    postMetaColor: '#a21caf',
    tagBackground: '#fdf4ff',
    tagText: '#86198f',
    tagActiveBackground: '#a855f7',
    tagActiveText: '#ffffff',
    sidebarBackground: '#ffffff',
    sidebarTitleColor: '#701a75',
    paginationBackground: '#ffffff',
    paginationText: '#86198f',
    paginationBorder: '#f0abfc',
    paginationActiveBackground: '#a855f7',
    paginationActiveText: '#ffffff',
    paginationDisabledOpacity: '0.5',
    iconColor: '#a21caf',
    loadingSpinnerColor: '#a855f7',
    errorIconColor: '#d8b4fe',
    errorButtonBackground: '#a855f7',
    errorButtonText: '#ffffff',
  },
};
